export default __webpack_public_path__ + "static/media/electrolytedrink-wide@3x.9e13ab03.jpg";